import { render, staticRenderFns } from "./NuevoLicitador.vue?vue&type=template&id=93d81cea&scoped=true&"
import script from "./NuevoLicitador.vue?vue&type=script&lang=js&"
export * from "./NuevoLicitador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d81cea",
  null
  
)

export default component.exports